import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateAllocatorStratgy } from "../../../allocator-portal/src/containers/Profile/actions";
import { Input, Select, Form, Button } from "antd";
import { InputDropdown } from "@public/ui-toolkit";
import { getNumberWithUnit } from "@hedgefund/shared";
import { alertService } from "../Alert";

const { Option } = Select;
const { TextArea } = Input;
const ProfileBulletPoints = ({ title, description, editButton, listData, openInput, setopenInput, value, setValue, onSubmit, investorData, stratagiesList }) => {
  const [decValue, setDecValue] = useState();
  const [selectedValue, setSelectedValue] = React.useState();
  const dispatch = useDispatch();

  const onUpdateList = () => {
    if (selectedValue) {
      dispatch(updateAllocatorStratgy(selectedValue));
    }
    setopenInput(false);
  };


  const onSuccess = () => {
    setopenInput(false);
    if (description === null) {
      alertService.success("Successfully Created.", { autoClose: true });
    } else {
      alertService.success("Updated Successfully.", { autoClose: true });
    }
  }
  const handleChangeIC = () => {
    if (selectedValue) {

      const obj = {
        investorTypeId: selectedValue
      }
      onSubmit(obj, onSuccess)
    } else {
      setopenInput(false)
    }
  }
  const ChangeToUnit = (value) => {
    setDecValue(Number(value));
  }
  return (
    <div className="rounded-large bg-white border pei-box">
      <div className="pei-box-title d-flex flex-row justify-content-between">
        <h5>{title}</h5>
        {(() => {

          if (editButton) {
            if (openInput) {
              return (
                <i
                  style={{ cursor: "pointer" }}
                  className="fa fa-close"
                  onClick={() => {
                    setValue();
                    setopenInput(false);
                  }}
                >
                </i>
              )
            } else {
              return (
                <i
                  style={{ cursor: "pointer" }}
                  className="fa fa-edit"
                  onClick={() => {
                    setValue();
                    setopenInput(true);
                  }}
                >
                </i>)
            }
          }
        })()}
      </div>
      <div className="row">
        <div className="col-lg-12 mb-lg-0 mb-3">
          {(() => {
            if (openInput) {
              if (investorData?.length) {
                return (
                  <>
                    <Form onFinish={handleChangeIC} layout={"vertical"}>
                      <Form.Item name={'selectedId'} label={'Please select from the following Investor Type.'} >
                        <InputDropdown
                          id="investorTypeId"
                          placeholder="Investor Type"
                          label="Investor Type"
                          inputDropdownOptions={investorData}
                          defaultOptionName={value?.name ? value?.name : "Investor Type"}
                          optionKey={"name"}
                          onChange={(e) => {
                            setSelectedValue(e.target.value)
                          }}
                          defaultValue={value?.value ? value?.value : 0}
                        />
                      </Form.Item>
                      <div class="modal-footer" style={{ padding: "0px" }}>
                        <Button htmlType="button" onClick={() => setopenInput(false)}> Close </Button>
                        <Button htmlType="submit" type="primary" style={{ backgroundColor: "#3ac1b5", color: "#fff", border: "1px solid #3ac1b5" }}> Save</Button>
                      </div>
                    </Form>
                  </>
                )
              } else if (listData?.length > 0) {
                return (
                  <>
                    <Form onFinish={onUpdateList} layout={"vertical"}>
                      <div style={{ minHeight: "350px" }}>
                        <Form.Item name={'selectedId'} label={'Please select from the following strategies.'} >
                          <Select
                            defaultValue={stratagiesList?.map((u) => { return ({ label: u?.name, value: u?.id }) })}
                            defaultOpen={true}
                            name={'name'}
                            mode={'multiple'}
                            onChange={(e) => setSelectedValue(e)}
                          >
                            {listData?.map((item) => {
                              return (<Option value={item?.id}>{item?.name}</Option>)
                            })}

                          </Select>
                        </Form.Item>
                      </div>
                      <div class="modal-footer" style={{ padding: "0px" }}>
                        <Button htmlType="button" className="btn btn-secondary" onClick={() => setopenInput(false)}>
                          Close
                        </Button>
                        <Button htmlType="submit" className="btn btn-secondary" onCli> Save</Button>
                      </div>
                    </Form>
                  </>
                )
              } else if (value?.name === "IDP") {
                return (
                  <>
                    <Form onFinish={() => {
                      if (selectedValue) {
                        onSubmit(selectedValue, onSuccess)
                      } else {
                        setopenInput(false)
                      }
                    }
                    } layout={"vertical"}>
                      <Form.Item name={'selectedId'} label={`Please Enter ${title}.`} >
                        <TextArea
                          type={"text"}
                          rows={5}
                          className="form-control"
                          placeholder={value?.name}
                          name={value?.name}
                          defaultValue={value?.value}
                          onChange={(e) => {
                            setSelectedValue(e.target)
                            ChangeToUnit(e.target.value)
                          }}
                          onPressEnter={(e) => {
                            onSubmit(e.target, onSuccess)
                          }}
                        />
                      </Form.Item>

                      <div class="modal-footer" style={{ padding: "0px" }}>
                        <Button htmlType="button" className="btn btn-secondary" onClick={() => setopenInput(false)}>
                          Close
                        </Button>
                        <Button htmlType="submit" className="btn btn-secondary"> Save</Button>
                      </div>
                    </Form>
                  </>
                )
              } else {
                return (
                  <>
                    <Form onFinish={() => {
                      if (selectedValue) {
                        onSubmit(selectedValue, onSuccess)
                      } else {
                        setopenInput(false)
                      }
                    }
                    } layout={"vertical"}>
                      <Form.Item name={'selectedId'} label={`Please Enter ${title}.`} style={{ margin : "0px", padding : "5px 0px" }} >
                        <Input
                          type={value?.name === "IDP" ? "text" : "number"}
                          className="form-control"
                          placeholder={value?.name}
                          name={value?.name}
                          defaultValue={value?.value}
                          onChange={(e) => {
                            setSelectedValue(e.target)
                            ChangeToUnit(e.target.value)
                          }}
                          onPressEnter={(e) => {
                            onSubmit(e.target, onSuccess)
                          }}
                        />
                      </Form.Item>
                      <span className="ml-2">{getNumberWithUnit(decValue ?? description)}</span>
                      <div class="modal-footer" style={{ padding: "0px" }}>
                        <Button htmlType="button" className="btn btn-secondary" onClick={() => setopenInput(false)}>
                          Close
                        </Button>
                        <Button htmlType="submit" className="btn btn-secondary"> Save</Button>
                      </div>
                    </Form>
                  </>
                )
              }
            } else {
              if (listData?.length > 0) {
                return (
                  <ul className="bullted-list">
                    {stratagiesList?.length > 0 ? (
                      <>
                        {stratagiesList.map((data, i) => 
                        { 
                          return(
                          <li key={i}> {data.name}</li>
                        )})}
                      </>
                    ) : (
                      <li> {"No activity found!"}</li>
                    )}

                  </ul>)
              } else if (title === "Investor Decision Process") {
                return (
                  <p>{description}</p>
                )
              } else {
                return (
                  <ul className="bullted-list">
                    <li>{description}</li>
                  </ul>)
              }
            }
          })()}
        </div>
      </div>
    </div>
  );
};

export default ProfileBulletPoints;
